export default "__VITE_ASSET__DgQ7glsy__"